import { render, staticRenderFns } from "./processInspection.vue?vue&type=template&id=bb79e95a&scoped=true&"
import script from "./processInspection.vue?vue&type=script&lang=js&"
export * from "./processInspection.vue?vue&type=script&lang=js&"
import style0 from "./processInspection.vue?vue&type=style&index=0&id=bb79e95a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb79e95a",
  null
  
)

export default component.exports